import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'; import { Table, TableCell, TableHead, TableRow, TextAreaField } from '@aws-amplify/ui-react';
import FileRow from './FileRow';
import UploadFileeDiscovery from "./UploadFileeDiscovery";
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import { ServerlessApplicationRepository } from 'aws-sdk';
import { 
  SortUp,
  SortDown
} from 'react-bootstrap-icons';

const UserFileseDiscovery = (props) => {
  const projectId = props.project_id
  const [entities, setEntities] = useState([])
  const [isBusy, setIsBusy] = useState(false);

  //Function to fetch from our backend and update customers array
  const getFiles = async (busy) => {
    if (busy == true)
      setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    API.get("DocumentSearchUser", "/getuserfiles" + `?projectid=${projectId}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        console.log(response)
        let newEntities = response
        setEntities(newEntities)
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };
  useEffect(() => { getFiles(true) }, [])

  const handleDelete = async (entity) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }

    console.log('delete ' + entity.file_name + ' ' + entity.project_id)
    API.get('DocumentSearchUser', '/deletefile' + `?projectid=${entity.project_id}&filename=${entity.file_name}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        getFiles();

      })
      .catch(error => {
        setIsBusy(false);
        console.log(error)
      })
  };

  const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

  const handleUpload = async() => {
    await sleep(2000)
    getFiles(false);
    await sleep(5000)
    getFiles(false);
  };
  
  const sortColumn = (column,direction) => {
    if (column === 'file_name') {
     if (direction === 'up') {
       const sorted = [...entities].sort((a,b) => { return a.file_name.localeCompare(b.file_name)})
       setEntities(sorted)
     } 
     else {
       const sorted = [...entities].sort((a,b) => { return b.file_name.localeCompare(a.file_name)})
       setEntities(sorted)
     }
    }
    else if (column === 'pages') {
      if (direction === 'up') {
       const sorted = [...entities].sort((a,b) => { return a.pages - b.pages})
       setEntities(sorted)
     } 
     else {
       const sorted = [...entities].sort((a,b) => { return b.pages- a.pages})
       setEntities(sorted)
     }     
    }
    else {
      if (direction === 'up') {
       const sorted = [...entities].sort((a,b) => { return a.size - b.size})
       setEntities(sorted)
      }  
      else {
       const sorted = [...entities].sort((a,b) => { return b.size - a.size})
       setEntities(sorted)
      }
    }
  }

  
  return (

    <div>
      <UploadFileeDiscovery entities={entities} project_id={projectId} onUpload={handleUpload} />      
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Table className='table table-striped' size='small'>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Document Name </strong>
              <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('file_name','up')}>
                <SortUp />
              </Button> 
              <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('file_name','down')}>
                <SortDown />
              </Button>          
            </TableCell>
            <TableCell>
              <strong>Format </strong>
            </TableCell>
            <TableCell>
              <strong>Pages </strong>
              <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('pages','up')}>
                <SortUp />
              </Button> 
              <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('pages','down')}>
                <SortDown />
              </Button> 
            </TableCell>
            <TableCell>
              <strong>Size </strong>
              <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('size','up')}>
                <SortUp />
              </Button> 
              <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('size','down')}>
                <SortDown />
              </Button>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <tbody>
          {
            entities.map((thisEntity, index) => {
              return (

                <FileRow key={thisEntity.id} entity={thisEntity} onDelete={handleDelete} index={index + 1} />
              )
            })
          }
        </tbody>
      </Table>
    </div>
  )
}
export default UserFileseDiscovery;